export const GET_DISTRICTS = '/get_districts';
export const GET_SINGLE_DISTRICT = '/get_single_district';
export const UPDATE_DISTRICT = '/update_district';
export const CREATE_DISTRICT = '/create_district';
export const REMOVE_DISTRICT = '/remove_district';
export const GET_PROVINCE_LIST = 'district/get_province_list';

export const FORM_DATA = {
  name: '',
  code: '',
  province_id: 65,
};